import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import { MoreVert, Edit, Delete, Folder } from '@mui/icons-material';
import { format } from 'date-fns';

const ProjectCard = ({ project, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEdit(project);
    handleMenuClose();
  };

  const handleDelete = () => {
    onDelete(project);
    handleMenuClose();
  };

  const getStatusColor = (status) => {
    const colors = {
      active: 'success',
      completed: 'primary',
      'on-hold': 'warning',
      archived: 'default',
    };
    return colors[status] || 'default';
  };

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box display="flex" alignItems="center" gap={1}>
            <Folder color="primary" />
            <Typography variant="h6" component="div">
              {project.name}
            </Typography>
          </Box>
          <IconButton size="small" onClick={handleMenuOpen}>
            <MoreVert />
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleEdit}>
              <Edit fontSize="small" sx={{ mr: 1 }} />
              Edit
            </MenuItem>
            <MenuItem onClick={handleDelete}>
              <Delete fontSize="small" sx={{ mr: 1 }} />
              Delete
            </MenuItem>
          </Menu>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2 }}>
          {project.description || 'No description'}
        </Typography>

        <Box display="flex" gap={1} alignItems="center">
          <Chip
            label={project.status}
            color={getStatusColor(project.status)}
            size="small"
          />
          <Typography variant="caption" color="text.secondary">
            Created {format(new Date(project.createdAt), 'MMM dd, yyyy')}
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          variant="contained"
          onClick={() => navigate(`/projects/${project._id}`)}
        >
          View Tasks
        </Button>
      </CardActions>
    </Card>
  );
};

export default ProjectCard;
